module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('carousel-3d', {
    attrs: {
      "autoplay": true,
      "autoplay-timeout": 5000,
      "display": 3
    }
  }, _vm._l((_vm.slides), function(slide, i) {
    return _c('slide', {
      key: i
    }, [_c('span', [_vm._v("you know")])])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f63486ec","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Point/effectRank.vue
// module id = 1662
// module chunks = 0